import { InfoCircleOutlined } from "@ant-design/icons";
import { Card, Col, Row, Table, Tooltip } from "antd";

export default function TablesWrapper({
  data,
  isLoading,
  tablesPerRow = 2,
  columns,
  tablesName,
}) {
  return (
    <div style={{ width: "85%", maxWidth: "100%" }}>
      <Row gutter={[16, 16]}>
        <Col xs={24} md={24 / tablesPerRow}>
          <Card
            title={
              <span>
                {tablesName[0]}{" "}
                <Tooltip title="Inclui apenas detecções de clientes">
                  <InfoCircleOutlined
                    style={{ fontSize: 13, color: "#9ca3af" }}
                  />
                </Tooltip>
              </span>
            }
            align="center"
            loading={isLoading}
            styles={{
              header: {
                backgroundColor: "var(--ouran-card-header-bg)",
              },
            }}>
            <Table
              columns={columns}
              dataSource={data?.["above_mean"]}
              loading={isLoading}
              responsive="stack"
              pagination={{
                pageSize: 10,
              }}
              scroll={{
                x: "max-content",
                y: 360,
              }}
            />
          </Card>
        </Col>
        <Col xs={24} md={24 / tablesPerRow}>
          <Card
            title={
              <span>
                {tablesName[1]}{" "}
                <Tooltip title="Inclui apenas detecções de clientes">
                  <InfoCircleOutlined
                    style={{ fontSize: 13, color: "#9ca3af" }}
                  />
                </Tooltip>
              </span>
            }
            align="center"
            loading={isLoading}
            styles={{
              header: {
                backgroundColor: "var(--ouran-card-header-bg)",
              },
            }}>
            <Table
              columns={columns}
              dataSource={data?.["below_mean"]}
              responsive="stack"
              pagination={{
                pageSize: 10,
              }}
              scroll={{
                x: "max-content",
                y: 360,
              }}
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
}
